module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1140);


/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ }),

/***/ 1009:
/***/ (function(module, exports) {

	module.exports = require("./kendo.combobox");

/***/ }),

/***/ 1010:
/***/ (function(module, exports) {

	module.exports = require("./kendo.dropdownlist");

/***/ }),

/***/ 1139:
/***/ (function(module, exports) {

	module.exports = require("./kendo.numerictextbox");

/***/ }),

/***/ 1140:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(f, define){
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [
	        __webpack_require__(1009), __webpack_require__(1010), __webpack_require__(1142), __webpack_require__(1143), __webpack_require__(1144), __webpack_require__(1145), __webpack_require__(1139),

	        __webpack_require__(1146),
	        __webpack_require__(1147),
	        __webpack_require__(1148),
	        __webpack_require__(1149),
	        __webpack_require__(1150),
	        __webpack_require__(1151),
	        __webpack_require__(1152),
	        __webpack_require__(1153),
	        __webpack_require__(1154),

	        __webpack_require__(1155),
	        __webpack_require__(1156),
	        __webpack_require__(1157),
	        __webpack_require__(1158),
	        __webpack_require__(1141),
	        __webpack_require__(1159),
	        __webpack_require__(1160),
	        __webpack_require__(1161),
	        __webpack_require__(1162),
	        __webpack_require__(1163),
	        __webpack_require__(1164),
	        __webpack_require__(1165),
	        __webpack_require__(1166),
	        __webpack_require__(1167),
	        __webpack_require__(1168),
	        __webpack_require__(1169),
	        __webpack_require__(1170),
	        __webpack_require__(1171),
	        __webpack_require__(1172),

	        __webpack_require__(1173),
	        __webpack_require__(1174),
	        __webpack_require__(1175),
	        __webpack_require__(1176),
	        __webpack_require__(1177),
	        __webpack_require__(1178)
	    ], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	})(function(){

	    var __meta__ = { // jshint ignore:line
	        id: "editor",
	        name: "Editor",
	        category: "web",
	        description: "Rich text editor component",
	        depends: [ "combobox", "dropdownlist", "window", "colorpicker" ],
	        features: [ {
	            id: "editor-imagebrowser",
	            name: "Image Browser",
	            description: "Support for uploading and inserting images",
	            depends: [ "imagebrowser" ]
	        }, {
	            id: "editor-resizable",
	            name: "Resize handle",
	            description: "Support for resizing the content area via a resize handle",
	            depends: [ "resizable" ]
	        }, {
	            id: "editor-tablewizard",
	            name: "Table wizard dialog",
	            description: "Support for table properties configuration",
	            depends: [ "tabstrip", "button", "numerictextbox" ]
	        }, {
	            id: "editor-pdf-export",
	            name: "PDF export",
	            description: "Export Editor content as PDF",
	            depends: [ "pdf", "drawing" ]
	        }]
	    };

		return window.kendo;

	}, __webpack_require__(3));


/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/image");

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

	module.exports = require("./kendo.resizable");

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

	module.exports = require("./kendo.window");

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

	module.exports = require("./kendo.colorpicker");

/***/ }),

/***/ 1145:
/***/ (function(module, exports) {

	module.exports = require("./kendo.imagebrowser");

/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

	module.exports = require("./util/undoredostack");

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

	module.exports = require("./editor/main");

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

	module.exports = require("./editor/dom");

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

	module.exports = require("./editor/serializer");

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

	module.exports = require("./editor/range");

/***/ }),

/***/ 1151:
/***/ (function(module, exports) {

	module.exports = require("./editor/command");

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

	module.exports = require("./editor/components");

/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

	module.exports = require("./editor/toolbar");

/***/ }),

/***/ 1154:
/***/ (function(module, exports) {

	module.exports = require("./editor/immutables");

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/viewhtml");

/***/ }),

/***/ 1156:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/link");

/***/ }),

/***/ 1157:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/lists");

/***/ }),

/***/ 1158:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/formatting");

/***/ }),

/***/ 1159:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/import");

/***/ }),

/***/ 1160:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/insert");

/***/ }),

/***/ 1161:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/export");

/***/ }),

/***/ 1162:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/indent");

/***/ }),

/***/ 1163:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/linebreak");

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/format");

/***/ }),

/***/ 1165:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/inlineformat");

/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/formatblock");

/***/ }),

/***/ 1167:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/file");

/***/ }),

/***/ 1168:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/tables");

/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/clipboard");

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/keyboard");

/***/ }),

/***/ 1171:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/exportpdf");

/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

	module.exports = require("./editor/plugins/print");

/***/ }),

/***/ 1173:
/***/ (function(module, exports) {

	module.exports = require("./editor/resizing/column-resizing");

/***/ }),

/***/ 1174:
/***/ (function(module, exports) {

	module.exports = require("./editor/resizing/row-resizing");

/***/ }),

/***/ 1175:
/***/ (function(module, exports) {

	module.exports = require("./editor/resizing/table-resizing");

/***/ }),

/***/ 1176:
/***/ (function(module, exports) {

	module.exports = require("./editor/resizing/table-resize-handle");

/***/ }),

/***/ 1177:
/***/ (function(module, exports) {

	module.exports = require("./editor/table-wizard/table-wizard-command");

/***/ }),

/***/ 1178:
/***/ (function(module, exports) {

	module.exports = require("./editor/table-wizard/table-wizard-dialog");

/***/ })

/******/ });